import { siteIDs } from '../../adapters/utils';
import adapter from './adapter-blog-hashtags';
import { buildLink, buildOgMeta, buildStandardMeta, buildTitle, } from '../../types/builders';
var IDs = adapter.IDs;
var SITE_NAME = siteIDs.SITE_NAME;
export var BLOG_HASHTAGS = {
    tags: [
        buildTitle("{{" + IDs.TITLE + "}}"),
        buildStandardMeta('robots', 'noindex'),
        buildLink('canonical', "{{" + IDs.URL + "}}"),
        buildLink('prev', "{{" + IDs.PREV_URL + "}}"),
        buildLink('next', "{{" + IDs.NEXT_URL + "}}"),
        buildOgMeta('og:title', "{{" + IDs.TITLE + "}}"),
        buildOgMeta('og:url', "{{" + IDs.URL + "}}"),
        buildOgMeta('og:site_name', "{{" + SITE_NAME + "}}"),
        buildOgMeta('og:type', 'website'),
    ],
};
